import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RouteService, StructService } from '../util/structService/struct-service';
import { AreaService } from './area.service';
import { SolicitarServicioService } from './solicitar-servicio.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceStructService {

constructor(
    private services: AreaService,
    private httpSolicitarServicio: SolicitarServicioService,
) { }
async requestService(structService: StructService, routeService: RouteService, json?: any): Promise<any>{
    debugger
    console.log('requestService')
    switch (routeService) {
        case RouteService.GetKeyGoogle:
                var promeseResult = await this.resultOfResponse(structService, this.services.onGetKey());
            break
            case RouteService.servicesAudit:
            break
            case RouteService.servicePosicionConductor:
                var promeseResult = await this.resultOfResponse(structService, this.httpSolicitarServicio.obtenerPosicionGoogle(json));
            break
            case RouteService.servicePosicionConductorDistancia:
                var promeseResult = await this.resultOfResponse(structService, this.httpSolicitarServicio.requestPosicionConductorDistancia(json));
                break
        default:
            break;
    }  
    return promeseResult
}
 async resultOfResponse(structService: StructService, routeService: Observable<any>): Promise<any> {
        switch (structService) {
            case StructService.ARRAY:
                try {
                    return await this.responseArray(routeService)
                }
                catch (error) {
                    return [];
                }
            case StructService.CODE:
                try {
                    return await this.responseCode(routeService)
                }
                catch (error) {
                    return error;
                }

            case StructService.GENERIC_OK:
                return this.responseGenericOk(routeService);

            // default:
            //   return this.responseCode(routeService);
        }
    }

    responseCode(serviceSuscrible: Observable<any>): any {
        return new Promise(function (resolve, reject) {
            serviceSuscrible.subscribe((response: any) => {
                resolve(response);
            }, error => {
                reject(error);
            });
        })
    }

    responseArray(serviceSuscrible: Observable<any>): Promise<any> {
        return new Promise(function (resolve, reject) {
            serviceSuscrible.subscribe((response: any[]) => {
                resolve(response);
            }, error => {
                reject(error);
            });
        })
    }

    responseGenericOk(serviceSuscrible: Observable<any>): any {
        var response: any;
        return response
    }

}
